"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m.52 0a.45.45 0 0 0 -.2 0 .45.45 0 0 1 .2 0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.32 24a.45.45 0 0 0 .16 0 .45.45 0 0 0 .2 0 .5.5 0 0 1 -.36 0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2.16 21.43a.41.41 0 0 0 .41.41h17.13l-17.54-17.54z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.72 8-5.72-5.72a.38.38 0 0 0 -.29-.12h-11.41l17.54 17.54v-11.39a.4.4 0 0 0 -.12-.31zm-6.44.7v-5.7l5.72 5.72z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.43 21.84h-.32l2 2a.59.59 0 0 0 .2.12.5.5 0 0 0 .36 0 .45.45 0 0 0 .17-.11.52.52 0 0 0 0-.73l-2-2v.32a.41.41 0 0 1 -.41.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2.57 2.16h.32l-2-2a.45.45 0 0 0 -.18-.16.43.43 0 0 0 -.19 0 .45.45 0 0 0 -.2 0 .45.45 0 0 0 -.17.15.52.52 0 0 0 0 .73l2 2v-.31a.41.41 0 0 1 .42-.41z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m2.57 2.16a.41.41 0 0 0 -.41.41v.32l19 19h.32a.41.41 0 0 0 .41-.41v-.32l-19-19z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m23.32 24a.59.59 0 0 1 -.2-.12.59.59 0 0 0 .2.12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m.52 0a.43.43 0 0 1 .19 0 .43.43 0 0 0 -.19 0z"
  })));
};

exports["default"] = _default;